import { gql } from '@apollo/client';
import { RouteOrderPoolItem } from './getRouteOrders';

export interface FastRoutePlanningResponse {
    fastRoutePlanning: RouteOrderPoolItem[];
}

export interface FastRoutePlanningVariables {
    warehouseId: number;
    areaId: number;
}

export const FAST_ROUTE_PLANNING_FOR_DSP = gql`
    query FastRoutePlanningForDsp($warehouseId: Long!, $areaId: Long!) {
        fastRoutePlanningForDsp(warehouseId: $warehouseId, areaId: $areaId) {
            id
            orderId
            trackingNumber
            status
            zipcode
            latitude
            longitude
            stopNumber
        }
    }
`;

export const FAST_ROUTE_PLANNING = gql`
    query FastRoutePlanning($warehouseId: Long!, $areaId: Long!) {
        fastRoutePlanning(warehouseId: $warehouseId, areaId: $areaId) {
            id
            orderId
            trackingNumber
            status
            zipcode
            latitude
            longitude
            stopNumber
        }
    }
`;
